import React from "react";
import cx from "clsx";
import { Publish } from "./Publish";
import { Unpublish } from "./Unpublish";
import { Delete } from "./Delete";
import { AddQuestion } from "./AddQuestion";
import { Save } from "./Save";
import styles from "./styles.module.scss";
import { useContext } from "../../../../context";

export const Actions = ({ mobile, className, onClick }) => {
  const { isEditMode, isPublished } = useContext();

  const actions = [
    {
      id: "publish",
      component: Publish,
      isVisible: isEditMode && !isPublished,
    },
    {
      id: "unpublish",
      component: Unpublish,
      isVisible: isEditMode && isPublished,
    },
    {
      id: "delete",
      component: Delete,
      isVisible: isEditMode,
    },
    {
      id: "add-question",
      component: AddQuestion,
      isVisible: true,
    },
    {
      id: "save",
      component: Save,
      isVisible: true,
    },
  ].filter((action) => action.isVisible);

  return (
    <div
      className={cx(
        {
          [styles.rootMobile]: mobile,
          [styles.root]: !mobile,
        },
        className,
      )}
    >
      {actions.map((action) => (
        <action.component key={action.id} onClick={onClick || (() => {})} />
      ))}
    </div>
  );
};
